/**
 * Site-wide constants: identity, contact details, navigation, CTA targets.
 *
 * Copy lives in data files rather than JSX so wording changes never touch
 * layout, and so every public claim changes through a reviewable diff.
 */

export const SITE = {
  name: 'Chickrah',
  domain: 'https://chickrah.com',
  tagline: 'Precision Poultry Management',
  // Mirrors the hero subheadline: this is the meta description and the OG
  // card, so it should say the same thing the page says.
  description:
    'No more paper logs, forgotten vaccines, or guessing your profit per flock. Message us on WhatsApp and we will set up your farm on Chickrah.',
};

export const CONTACT = {
  email: 'chickrahfarming@gmail.com',
  phones: [
    { country: 'Kenya', display: '+254 768 282979', e164: '254768282979' },
    { country: 'Uganda', display: '+256 773 911534', e164: '256773911534' },
  ],
  regions: 'Kenya & Uganda',
};

/**
 * Primary WhatsApp line (Uganda, +256 773 911534), prefilled so the operator
 * isn't retyping context. Every WhatsApp link on the site reads this: the hero
 * and header CTAs, the floating widget, the demo form and the contact page.
 */
export const WHATSAPP = {
  number: CONTACT.phones[1].e164,
  message: "Hi Chickrah, I'd like to see how this would work for my farm.",
  get url() {
    return `https://wa.me/${this.number}?text=${encodeURIComponent(this.message)}`;
  },
};

/**
 * Empty by design. Every link that lived here now has a better home: pricing is
 * where "Get started" goes, and contact is the demo form. The header keeps the
 * logo and the one action, which is what a single-page site actually needs.
 *
 * SiteHeader reads the length — put an item back and the desktop nav and the
 * mobile drawer both return on their own.
 */
export const NAV = [];

/**
 * The product lives at app.chickrah.com but is not hosted yet. Until it is,
 * "Get started" routes to the demo request form. Flipping this one value
 * switches every CTA across the site.
 */
export const APP_URL = null; // e.g. 'https://app.chickrah.com/login'

/**
 * "Get started" opens a WhatsApp chat: in this market that is how farms prefer
 * to make first contact, and it is faster than any form. The tier cards still
 * carry their own "Book a demo" button for anyone who wants the form.
 */
export const PRIMARY_CTA = { label: 'Get Started', to: APP_URL ?? WHATSAPP.url };

export const FOOTER_LINKS = [
  {
    heading: 'Product',
    links: [
      { label: 'Pricing', to: '/#pricing' },
      { label: 'In action', to: '/#in-action' },
      { label: 'Results', to: '/#results' },
      { label: 'Book a demo', to: '/demo' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      // Straight to the form. /contact still resolves for anyone holding the
      // old link, but there is no reason to send footer traffic via a redirect.
      { label: 'Contact', to: '/demo' },
    ],
  },
];
